export const VERSION = "1.0"
export const COPYRIGHT = "2026"